import { render, staticRenderFns } from "./ExpiredMemberCard.vue?vue&type=template&id=70d0e13b&scoped=true&"
import script from "./ExpiredMemberCard.vue?vue&type=script&lang=js&"
export * from "./ExpiredMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredMemberCard.vue?vue&type=style&index=0&id=70d0e13b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0e13b",
  null
  
)

export default component.exports